import { render, staticRenderFns } from "./AlipayWithhold.vue?vue&type=template&id=6c5b69bc&scoped=true"
import script from "./AlipayWithhold.vue?vue&type=script&lang=js"
export * from "./AlipayWithhold.vue?vue&type=script&lang=js"
import style0 from "./AlipayWithhold.vue?vue&type=style&index=0&id=6c5b69bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5b69bc",
  null
  
)

export default component.exports